import { ITextTheme } from '../../models/ITextTheme';
import { colors } from './colors';

export const TextTheme: ITextTheme = {
  dark: colors.neutral.gray,
  grey: colors.neutral.grayCold,
};
